import { render } from "./OrderInfo.vue?vue&type=template&id=e344af3a&scoped=true"
import script from "./OrderInfo.vue?vue&type=script&lang=js"
export * from "./OrderInfo.vue?vue&type=script&lang=js"

import "./OrderInfo.vue?vue&type=style&index=0&id=e344af3a&scoped=true&lang=css"

import exportComponent from "/var/www/abg/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e344af3a"]])

export default __exports__